module.exports = "<div class=\"container w-xxl w-auto-xs\"><h3 class=\"text-danger wrapper\" ng-if=\"$ctrl.error\">{{$ctrl.error}}</h3><div ng-if=\"!$ctrl.error\"><div class=\"text-center text-muted\"><i class=\"fa-4x fa fa-circle-o-notch fa-spin\"></i><div class=\"m-t-xs\">&nbsp;Loading...</div></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/authorise/authorise.pug
// module id = 210
// module chunks = 0